import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CaretUp, CaretDown } from '@phosphor-icons/react';
import './style';

const Accordion = (props) => {
  const {
    title,
    content,
    initialState,
    className,
    width,
    ...attr
  } = props;

  const [isOpen, setIsOpen] = useState(initialState);

  const onClick = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div
      className={`accordion-wrapper flex flex-col gap-1 ${isOpen ? 'open' : 'closed'} ${className}`}
      {...(width && ({ style: { width } }))}
      {...attr}
    >
      <div
        className="accordion-title text-black label-18 flex items-center gap-4 justify-between pl-1 pr-2 py-1"
        onClick={onClick}
      >
        {title}
        {isOpen ? (
          <CaretUp size={16}
            color="#101010" />
        ) : (
          <CaretDown size={16}
            color="#101010" />
        )}
      </div>
      {isOpen && (
        <div className="accordion-content text-justify text-16 text-grey-70 p-1 pr-9">
          {content}
        </div>
      )}
    </div>
  );

};

Accordion.propTypes = {
  title: PropTypes.node,
  content: PropTypes.node,
  initialState: PropTypes.bool,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Accordion.defaultProps = {
  title: null,
  content: null,
  initialState: false,
  className: '',
  width: 396,
};

export default Accordion;
